import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, forwardRef, OnDestroy, OnInit, Output, Provider } from '@angular/core';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AnalyticsService } from '../../../modules/analytics/services/analytics.service';

@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class Step implements ControlValueAccessor, OnDestroy, OnInit {
  @Output() formReady: EventEmitter<string> = new EventEmitter<string>();
  @Output() goBack: EventEmitter<string> = new EventEmitter<string>();

  inProgress: boolean;
  control: UntypedFormGroup;
  protected notifier = new Subject<void>();

  abstract formName: string;
  abstract stepName: string;

  protected constructor(protected fb: UntypedFormBuilder, protected analyticsService: AnalyticsService) {}

  set formValue(value) {
    this.control.patchValue(value);
    this.onModelChange(value);
    this.onTouch();
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.buildForm();
    this.analytics();
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  registerOnChange(fn): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouch = fn;
  }

  writeValue(value): void {
    if (value) {
      this.formValue = value;
    } else {
      this.control.reset();
    }
  }

  public navigate(): void {
    if (this.control.valid) {
      this.formReady.emit();
    }
  }

  public navigateBack(): void {
    this.goBack.emit();
  }

  protected onTouch: any = () => {};
  protected onModelChange: any = () => {};

  protected valueChanges(values) {
    this.onModelChange(values);
  }

  protected subscribeToValueChanges(navigate = true, callback: (...args) => void = null): void {
    this.control.valueChanges.pipe(skip(1), takeUntil(this.notifier)).subscribe((values: any) => {
      this.onTouch();
      this.valueChanges(values);

      if (callback) {
        callback(values);
      }

      if (navigate) {
        this.navigate();
      }
    });
  }

  private analytics() {
    this.analyticsService.push({
      event: `${this.formName}-Step`,
      page: {
        step: `${this.formName}.${this.stepName}`,
      },
    });
  }

  protected abstract buildForm();
}

export const createProvider = (customClass: any): Provider => ({
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => customClass),
  multi: true,
});
